// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Json_decode from "../../../../node_modules/@glennsl/bs-json/src/Json_decode.bs.js";
import * as StringUtils from "../utils/StringUtils.bs.js";

function id(t) {
  return t.id;
}

function name(t) {
  return t.name;
}

function decode(json) {
  return {
          id: Json_decode.field("id", Json_decode.string, json),
          name: Json_decode.field("name", Json_decode.string, json)
        };
}

function color(t) {
  return StringUtils.toColor(t.name);
}

export {
  id ,
  name ,
  decode ,
  color ,
}
/* No side effect */
